import React from "react";
import { CalendarDays, Building2, Route, Users, BarChart3, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import solutions from "../../../data/solutions";

const icons = { calendar: CalendarDays, building: Building2, route: Route, users: Users, chart: BarChart3, shield: ShieldCheck };

const SolutionsSection = () => (
  <section id="solutions" className="py-24 bg-paper-200 border-y border-paper-300">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {solutions.map(({ slug, icon, title, body }) => {
          const Icon = icons[icon];
          return (
          <Link to={`/solutions/${slug}`} key={slug} className="bg-paper border border-paper-300 rounded-lg p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-brand-card hover:border-brand-500/40">
            <div className="w-10 h-10 rounded-md bg-brand-50 grid place-items-center mb-5">
              <Icon size={20} className="text-brand-600" />
            </div>
            <h3 className="font-display text-xl font-semibold text-ink mb-2">{title}</h3>
            <p className="text-sm text-ink-muted leading-relaxed">{body}</p>
          </Link>
        )})}
      </div>
    </div>
  </section>
);

export default SolutionsSection;
